import type { PostHog } from 'posthog-js';

let instance: PostHog | null = null;
let loadPromise: Promise<PostHog> | null = null;

export const loadPosthog = (): Promise<PostHog> => {
  if (instance) return Promise.resolve(instance);
  if (loadPromise) return loadPromise;

  loadPromise = import('posthog-js').then(mod => {
    instance = mod.posthog;
    return instance;
  });

  return loadPromise;
};

export const getPosthog = (): PostHog | null => instance;
